var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9992 7.9464C28.043 8.3589 27.0023 8.65577 25.9305 8.7714C27.0433 8.11026 27.8767 7.06577 28.2742 5.8339C27.2299 6.45512 26.0859 6.89072 24.893 7.1214C24.3944 6.58836 23.7913 6.16371 23.1214 5.87392C22.4515 5.58413 21.7291 5.43541 20.9992 5.43702C18.0461 5.43702 15.6711 7.83077 15.6711 10.7683C15.6711 11.1808 15.7211 11.5933 15.8023 11.9901C11.3805 11.7589 7.43672 9.6464 4.81484 6.41202C4.33711 7.22801 4.08676 8.15711 4.08984 9.10265C4.08984 10.9526 5.03047 12.5839 6.46484 13.5433C5.61954 13.51 4.79404 13.2776 4.05547 12.8651V12.9308C4.05547 15.5214 5.88672 17.6683 8.32734 18.162C7.86909 18.2811 7.39768 18.342 6.92422 18.3433C6.57734 18.3433 6.24922 18.3089 5.91797 18.262C6.59297 20.3745 8.55859 21.9089 10.8992 21.9589C9.06797 23.3933 6.77422 24.237 4.28359 24.237C3.83672 24.237 3.42422 24.2214 2.99609 24.1714C5.35859 25.687 8.16172 26.562 11.1805 26.562C20.9805 26.562 26.343 18.4433 26.343 11.3964C26.343 11.1651 26.343 10.9339 26.3273 10.7026C27.3648 9.94327 28.2742 9.00265 28.9992 7.9464Z",
    fill: "#55ACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOutlined);
export default __webpack_public_path__ + "static/media/TwitterOutlined.9522fff59c547e3ecd2fdd862466ead6.svg";
export { ForwardRef as ReactComponent };